/** *************** getters ***********************/
export const GET_INFO = 'GET_INFO'
export const GET_TOKEN = 'GET_TOKEN'
export const GET_USER = 'GET_USER'
export const GET_LOADERS = 'GET_LOADERS'

/** *************** mutations - setters ***********************/
export const SET_INFO = 'SET_INFO'
export const SET_STATE = 'SET_STATE'
export const SET_STATE_PERSIST_LOCAL = 'SET_STATE_PERSIST_LOCAL'
export const SET_TOGGLE_LOADER = 'SET_TOGGLE_LOADER'

/** *************** actions - asynchronous ***********************/
export const RUN_LOGIN = 'RUN_LOGIN'
export const RUN_USER_LOGIN_2FA = 'RUN_USER_LOGIN_2FA'
export const RUN_STATE_LOAD = 'RUN_STATE_LOAD'
export const RUN_LOGOUT = 'RUN_LOGOUT'
export const RUN_FORGOT_PASSWORD = 'RUN_FORGOT_PASSWORD'
export const RUN_RESET_PASSWORD_FROM_HASH	= 'RUN_RESET_PASSWORD_FROM_HASH'
export const RUN_CHANGE_PASSWORD	= 'RUN_CHANGE_PASSWORD'



// WEBPACK FOOTER //
// ./src/types.js